@let groupe = groupeEtapes();
@let lectureSeule = !peutModifier();

<div
  class="m-sm"
  [class.!z-40]="estDeployee()"
  [class]="{
    'groupe-erreur': aDoublons(),
    'groupe-etapes-a-la-carte': !aDoublons(),
  }"
  [fNodeId]="groupe.id"
  [fInputId]="'input--' + groupe.id"
  [fNodePosition]="{
    x: groupe.metadonnees.x,
    y: groupe.metadonnees.y,
  }"
  [fNodeSize]="{
    height: height(),
    width: TAILLE_NOEUD_DEFAULT.width * (estDeployee() ? 2 : 1),
  }"
  [hlmContextMenuTrigger]="nodeContextMenu"
  [hlmContextMenuTriggerData]="{ data: groupe }"
  [fNodeDraggingDisabled]="lectureSeule"
  [fInputDisabled]="lectureSeule"
  fNode
  fNodeInput
  fDragHandle
  fInputConnectableSide="left"
  hlmTooltipTrigger="Groupe d'étapes à la carte"
>
  <div
    class="left"
    [fOutputId]="'output--' + groupe.id + '--l'"
    [fOutputMultiple]="true"
    [fOutputDisabled]="lectureSeule"
    fNodeOutput
    fOutputConnectableSide="left"
  ></div>

  <div class="text-components-content-neutral-primary gap-xxs flex" [class]="{ 'header-groupe-erreur': aDoublons() }">
    <div class="text-primary"><ng-icon name="lucideGroup" /></div>
    <span class="paragraph-medium-semibold bold">{{ groupe.nom }}</span>
  </div>

  <div class="text-content-primary" [class]="{ 'px-sm': aDoublons() }">
    <div class="py-xs px-sm border-stroke-neutral-light -mx-md flex flex-col border-y border-b-0">
      @if (groupe.duree; as duree) {
        <div class="flex">
          <span class="text-content-tertiary">Nombre d'étapes possibles :&nbsp;</span>
          <span>{{ duree ?? 0 }}</span>
        </div>
      }
      <div class="flex">
        <span class="text-content-tertiary">Nombre d'étapes dans le groupe :&nbsp;</span>
        <span>{{ groupe.etapes.length }}</span>
      </div>
    </div>
    @if (estDeployee()) {
      <div class="pt-md -mx-md border-t-stroke-neutral-light border-t">
        <span class="component-small-semibold px-sm">Contenu du groupe d'étapes</span>
        @for (etape of groupe.etapes; track etape.id; let last = $last) {
          <div
            class="py-xxs px-sm flex max-h-[48px] items-center justify-between"
            [class.border-b]="!last"
            [class.border-stroke-neutral-light]="!last"
          >
            <div class="component-small-medium">
              <span class="text-content-tertiary">{{ etape.codeEtape }} : </span>
              <span>{{ etape.nom }}</span>
            </div>
            <div class="gap-xxs flex">
              <button (click)="centrerEtape(etape.id)" size="xxl" hlmBtn variant="ghost">
                <ng-icon name="lucideArrowRight"></ng-icon>
              </button>
              @if (peutModifier()) {
                <button (click)="toggleEtape(etape)" size="xxl" hlmBtn variant="ghost">
                  <ng-icon name="lucideTrash"></ng-icon>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>

  <button class="mx-auto mt-auto" (click)="toggleGroupe()" size="xxl" hlmBtn variant="ghost">
    <ng-icon class="collapse-icon" [class.rotated]="estDeployee()" name="lucideChevronDown" />
  </button>

  <div
    class="right"
    [fOutputId]="'output--' + groupe.id + '--r'"
    [fOutputMultiple]="true"
    [fOutputDisabled]="lectureSeule"
    fNodeOutput
    fOutputConnectableSide="right"
  ></div>
</div>

<ng-template #nodeContextMenu let-data="data">
  <app-context-menu [menuItems]="nodeContextMenuItems()" [data]="data" />
</ng-template>
